/* One native bundle parent per request. Never retry an uncertain cart mutation. */
(function (scope) {
  function create({fetch, storage, root = '/', uuid}) {
    const base = root.replace(/\/?$/, '/');
    const key = 'sitr-starter-cart-pending-v1';
    let busy = false;
    return {
      pending() { try { return Boolean(storage.getItem(key)); } catch { return false; } },
      async add(id, {checkout = false} = {}) {
        if (busy) return {status: 'busy'};
        busy = true;
        try {
          if (!/^\d+$/.test(String(id))) return {status: 'invalid'};
          // Storage is required so a lost response followed by refresh cannot duplicate an add.
          if (storage.getItem(key)) return {status: 'uncertain'};
          const token = uuid();
          storage.setItem(key, token);
          if (storage.getItem(key) !== token) return {status: 'storage'};
          let response;
          try {
            response = await fetch(base + 'cart/add.js', {
              method: 'POST', credentials: 'same-origin',
              headers: {'Content-Type': 'application/json', Accept: 'application/json'},
              body: JSON.stringify({items: [{id: String(id), quantity: 1, properties: {_starter_request: token}}]})
            });
            if (!response.ok) {
              // Shopify may return errors after partial processing. Never assume it is safe to resubmit.
              let diagnostic='';
              try {const error=await response.json();diagnostic=String(error.description||error.message||'').slice(0,200);} catch {}
              return {status: 'uncertain', http: response.status, diagnostic};
            }
            const result = await response.json();
            if (!Array.isArray(result.items) || !result.items.length) return {status: 'uncertain'};
          } catch { return {status: 'uncertain'}; }
          // Keep marker until cart page loads. The builder cannot submit again after back/refresh.
          return {status: 'added', cart: base + 'cart', next: base + (checkout ? 'checkout' : 'cart')};
        } catch { return {status: 'storage'}; }
        finally { busy = false; }
      }
    };
  }
  scope.SitrStarterCart = {create};
  if (typeof module !== 'undefined') module.exports = {create};
})(typeof window === 'undefined' ? globalThis : window);
